module.exports = __webpack_public_path__ + "img/Energetic_Logo_3-1024x280.d7a017c5.png";